import React from 'react';
import mFormStyle from "@src/assets/_libs/module/_m-form.module.scss";
import lWrapperStyle from "@src/assets/_libs/layout/_l-wrapper.module.scss";
import lSubHeaderStyle from "@src/assets/_libs/layout/_l-sub-header.module.scss";
import sanitizeHtml from "sanitize-html";
import { IndicatorArea } from "./IndicatorArea";


export const SubHeaderArea = (props: { title: string, subtitle?: string, currentPhase?: number }) => {
  const { title, subtitle, currentPhase } = props;
  const sanitizedContent = sanitizeHtml(subtitle, {
    allowedTags: ["b", "i", "em", "strong", "p", "br", "a"], // 許可するタグを指定しておくことで、XSS攻撃を防ぐ
    allowedAttributes: {},
  });
  return (
    <header className={mFormStyle["m-form-header"]}>
      <div className={lWrapperStyle["l-wrapper"]}>
        {currentPhase && <IndicatorArea currentPhase={currentPhase} allStep={4} />}
        <h1 className={lSubHeaderStyle["l-sub-header__title1"] + " p-top0"}>{title}</h1>
        {subtitle && <p className={lSubHeaderStyle["l-sub-header__subtitle1"] + " m-top20 m-bottom0"} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />}
      </div>
    </header >
  );
};